"use client"

import { useEffect, useRef } from 'react'
import { useInputValueStore } from './InputValueStoreProvider'
import lowCase from '@utils/string/lowCase'

export function WhenHasDeps ({ children, compare, deps }) {
    const { getValues, hasValues, setValue } = useInputValueStore()
    const ref = useRef()
    const hasDeps = deps ? hasValues(deps) : true
    const depValues = deps ? getValues(deps) : []
    const depsMatch = deps && compare ? depValues.some(val1 => compare.some(val2 => lowCase(val1).includes(lowCase(val2)))) : true

    useEffect(() => {
        if (hasDeps && depsMatch) return
        const inputs = ref.current.querySelectorAll('input, textarea')
        if (inputs) [...inputs].forEach(input => {
            const { name, type } = input
            setValue(name, '')
            type == 'checkbox'
                ? input.checked = false
                : input.value = ''
        })
    }, [hasDeps, depsMatch, setValue])

    return (
        <div
            ref={ref}
            style={hasDeps && depsMatch ? undefined : { display: 'none' }}
        >
            {children}
        </div>
    )
}